var selectPPLParcelshop;

//ppl parcelshop SK

(function($){

    var $fn = $(".elm_select_branches_ppl_parcelshop");

    function SelectPPLParcelshopClass()
    {

        var _this = this;
        this.countryCode = null;
        this.selectElem = null;

        this.init = function()
        {

            this.selectElem = $('#ppl_parcelshop');
            this.countryCode = $('.elm_select_branches_ppl_parcelshop').attr('data-country');

            function initTippyPPLParcelshop()
            {
                const template = document.querySelector('#pplParcelshopOpenHours');
                var initialText;
                if(template !== null && template) {
                    initialText = template.textContent;
                } else {
                    initialText = '...';
                }

                var tip = tippy('.openingHoursBalikNaPostu', {
                    animation: 'shift-toward',
                    arrow: true,
                    html: '#pplParcelshopOpenHours',
                    onShow(instance) {
                        // `this` inside callbacks refers to the popper element
                        var content = this.querySelector('.tippy-content');

                        var customUrl = $(instance.reference).attr('data-url');

                        if (tip.loading || content.innerHTML !== initialText) return;

                        tip.loading = true;

                        $.ajax({
                            url: customUrl,
                            dataType: 'html'
                        }).done(function(data) {
                            content.innerHTML = data;
                            tip.loading = false
                        });

                    },
                    onHidden() {
                        const content = this.querySelector('.tippy-content');
                        content.innerHTML = initialText
                    },
                    // prevent tooltip from displaying over button
                    popperOptions: {
                        modifiers: {
                            preventOverflow: {
                                enabled: false
                            },
                            hide: {
                                enabled: false
                            }
                        }
                    }
                });
            }

            $(window).on('load',function() {
                initTippyPPLParcelshop();
            });

            function selectTemplatePPLParcelshop(data, container) {
                if(!data) {
                    return ;
                }
                if(data.element && data.element.dataset && data.element.dataset.id) {
                    var branchId = data.element.dataset.id;
                    var city = data.element.dataset.city;
                    var city_part = data.element.dataset.city_part;
                    var address = data.element.dataset.address;
                    var zip = data.element.dataset.zip;
                    var id_db = data.element.dataset.id_db;
                } else {
                    var branchId = data.id;
                    var city = data.city;
                    var city_part = data.city_part;
                    var address = data.address;
                    var zip = data.zip;
                    var id_db = data.id_db;
                }

                if(city == city_part) {
                    city_part = '';
                } else {
                    city_part = ' ' + city_part;
                }

                if (!branchId) {
                    return "";
                } else {
                    return $(
                        "<div class='balikovna-address-content'><div class='cityPart'>" + city + ",</div>" +
                        "<div class='address'>&nbsp;" + address + city_part +  ",</div>" +
                        "<div class='kind'>&nbsp;" + zip + "</div></div>" +
                        "<div class='openingHoursBalikNaPostu tooltipTrigger icon icon--clock' data-url='?do=pplParcelshopGetOpenins&bId="+ id_db +"&countryCode=" + _this.countryCode + "'>" + "" + "</div>"
                    );
                }
            }

            var searchPPLParcelshop;

            var selectElement = _this.selectElem;
            var defaultValueId = selectElement.attr('data-default-id');

            selectElement.select2({
                language: "cs",
                ajax: {
                    url: "?do=searchPPLParcelshop&countryCode=" + _this.countryCode,
                    data: function (params) {
                        searchPPLParcelshop = params.term;
                        return {
                            q: params.term,
                        };
                    },
                    processResults: function (data) {
                        setTimeout(function () {
                            initTippyPPLParcelshop();
                        }, 300);
                        return {
                            results: $.map(data.branches, function (item) {
                                return {
                                    id: item.id,
                                    text: item.name,
                                    city: item.city,
                                    city_part: item.city_part,
                                    address: item.address,
                                    zip: item.zip,
                                    id_db: item.id_db
                                }
                            })
                        };
                    },
                    complete: function () {
                        if (searchPPLParcelshop !== undefined) {
                            setTimeout(function () {
                                initTippyPPLParcelshop();
                            }, 100);
                        }
                    }
                },
                minimumInputLength: 1,
                templateResult: selectTemplatePPLParcelshop(),
                templateSelection: selectTemplatePPLParcelshop
            });

            if(defaultValueId) {

                $.ajax({
                    url: "?do=searchPPLParcelshop&countryCode=" + _this.countryCode + "&defaultId=" + defaultValueId,
                    dataType: 'json'
                }).done(function(data) {
                    if(data.branches && data.branches.length === 1) {

                        var branchData = data.branches[0];

                        var option = new Option(branchData.address, branchData.id, true, true);

                        for (let objKey in branchData) {
                            option.dataset[objKey] = branchData[objKey];
                        }

                        selectElement.append(option).trigger('change');

                        selectElement.trigger({
                            type: 'select2:select',
                            params: {
                                data: branchData
                            }
                        });
                    }
                });

            }

            selectElement.on('select2:select',function() {
                setTimeout(function () {
                    initTippyPPLParcelshop();
                }, 100);
            });


        };

    }

    selectPPLParcelshop = new SelectPPLParcelshopClass();

    if ($fn.length) {
        selectPPLParcelshop.init();
    }

})(jQuery);
